import { render, staticRenderFns } from "./wysiwygEditor.vue?vue&type=template&id=2b3f37ee&"
import script from "./wysiwygEditor.vue?vue&type=script&lang=js&"
export * from "./wysiwygEditor.vue?vue&type=script&lang=js&"
import style0 from "./wysiwygEditor.vue?vue&type=style&index=0&id=2b3f37ee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports